import { render, staticRenderFns } from "./CreditCardModalMagensa.vue?vue&type=template&id=5c139f8e&scoped=true"
import script from "./CreditCardModalMagensa.vue?vue&type=script&lang=js"
export * from "./CreditCardModalMagensa.vue?vue&type=script&lang=js"
import style0 from "./CreditCardModalMagensa.vue?vue&type=style&index=0&id=5c139f8e&prod&scoped=true&lang=scss"
import style1 from "./CreditCardModalMagensa.vue?vue&type=style&index=1&id=5c139f8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c139f8e",
  null
  
)

export default component.exports